import './Dashboard.css'
import { useHistory, useParams } from 'react-router-dom'
import { useAuth } from '../../auth/Auth'
import { useUserAccess } from '../../hooks/useUserAccess'
import ConsumerView from './views/ConsumerView'
import ConsumerGuestView from './views/ConsumerGuestView'
import { useEffect, useState } from 'react'
import { useData } from '../../data/DataProvider'
import { loadStripe } from '@stripe/stripe-js'
import { STRIPE_API_KEY } from '../../constants'
import { UserWalletApi } from '../../apis/UserWallet'

const Dashboard = (props) => {
    let { pathId } = useParams()
    const auth = useAuth()
    const data = useData()

    const { isConsumer, isConsumerGuest } = useUserAccess()
    const history = useHistory()
    const stripePromise = loadStripe(STRIPE_API_KEY)

    const [isLoading, setIsLoading] = useState(true)
    const [showManageBilling, setShowManageBilling] = useState(false)
    const [userWalletData, setUserWalletData] = useState([])
    const [myProperty, setMyProperty] = useState({})
    const [isRecurring, setIsRecurring] = useState(false)

    const manageBilling = () => {
        history.push('/dashboard/manage-billing')
        setShowManageBilling(true)
    }

    const navigateToChargingHistory = () => {
        history.push('/dashboard/manage-billing/charging-history')
    }

    useEffect(() => {
        if (pathId === 'manage-billing') {
            setShowManageBilling(true)
        } else {
            setShowManageBilling(false)
        }
    }, [pathId])

    useEffect(() => {
        if (showManageBilling === false) {
            history.push('/dashboard')
        }
    }, [showManageBilling])

    const reloadWallet = () => {
        data.loadUserWallet()
        UserWalletApi.get()
            .then((walletData) => {
                setUserWalletData(walletData)
                setIsLoading(false)
            })
            .catch((error) => {
            })
    }

    useEffect(() => {
        if (data.userProperties?.length > 0) {
            setMyProperty(data.userProperties[0])
            setIsRecurring(data.userProperties[0].billingModel.energyModel === 'RECURRING')
        }
        if (data.userWallet?.length > 0) {
            setUserWalletData(data.userWallet)
        }
    }, [data.userProperties, data.userWallet])

    useEffect(() => {
        setIsLoading(true)
        reloadWallet()
    }, [])

    useEffect(() => {
        // make sure call only happens on dashboard and not on manage billing, there we get session data by pagination only
        if (showManageBilling === false) {
            const intervalId = setInterval(() => {
                data.loadDashboardSessionData()
            }, 15000) // update sessions every 15 seconds

            //cleanup function to clear the interval on component unmount
            return () => clearInterval(intervalId)
        }
    }, [showManageBilling])

    return (
        <div className="dashboard-page-container">
            {isConsumer() && (
                <ConsumerView
                    data={data}
                    isLoading={isLoading}
                    myProperty={myProperty}
                    isRecurring={isRecurring}
                    setIsLoading={setIsLoading}
                    userWalletData={userWalletData}
                    stripePromise={stripePromise}
                    reloadWallet={reloadWallet}
                    setShowManageBilling={setShowManageBilling}
                    showManageBilling={showManageBilling}
                    manageBilling={manageBilling}
                    navigateToChargingHistory={navigateToChargingHistory}
                />
            )}
            {isConsumerGuest() && (
                <ConsumerGuestView
                    data={data}
                    isLoading={isLoading}
                    myProperty={myProperty}
                    isRecurring={isRecurring}
                    setIsLoading={setIsLoading}
                    userWalletData={userWalletData}
                    stripePromise={stripePromise}
                    reloadWallet={reloadWallet}
                    setShowManageBilling={setShowManageBilling}
                    showManageBilling={showManageBilling}
                    manageBilling={manageBilling}
                    navigateToChargingHistory={navigateToChargingHistory}
                />
            )}
        </div>
    )
}

export default Dashboard
